var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuiltInAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0042 18.6697C7.41125 18.6697 5.30225 16.5607 5.30225 13.9667C5.30225 11.3737 7.41125 9.26367 10.0042 9.26367C12.5982 9.26367 14.7072 11.3737 14.7072 13.9667C14.7072 16.5607 12.5982 18.6697 10.0042 18.6697ZM10.0042 10.3652C8.0192 10.3652 6.4032 11.9812 6.4032 13.9662C6.4032 15.9522 8.0192 17.5662 10.0042 17.5662C11.9892 17.5662 13.6062 15.9522 13.6062 13.9662C13.6062 11.9812 11.9892 10.3652 10.0042 10.3652Z",
    fill: "#6B696A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0042 18.4197C7.54935 18.4197 5.55225 16.4226 5.55225 13.9667H5.05225C5.05225 16.6987 7.27314 18.9197 10.0042 18.9197V18.4197ZM5.55225 13.9667C5.55225 11.5117 7.54939 9.51367 10.0042 9.51367V9.01367C7.27311 9.01367 5.05225 11.2357 5.05225 13.9667H5.55225ZM10.0042 9.51367C12.4601 9.51367 14.4572 11.5117 14.4572 13.9667H14.9572C14.9572 11.2356 12.7364 9.01367 10.0042 9.01367V9.51367ZM14.4572 13.9667C14.4572 16.4226 12.4602 18.4197 10.0042 18.4197V18.9197C12.7363 18.9197 14.9572 16.6987 14.9572 13.9667H14.4572ZM10.0042 10.1152C7.88113 10.1152 6.1532 11.8432 6.1532 13.9662H6.6532C6.6532 12.1193 8.15727 10.6152 10.0042 10.6152V10.1152ZM6.1532 13.9662C6.1532 16.0904 7.88126 17.8162 10.0042 17.8162V17.3162C8.15713 17.3162 6.6532 15.814 6.6532 13.9662H6.1532ZM10.0042 17.8162C12.127 17.8162 13.8562 16.0905 13.8562 13.9662H13.3562C13.3562 15.8139 11.8514 17.3162 10.0042 17.3162V17.8162ZM13.8562 13.9662C13.8562 11.8431 12.1272 10.1152 10.0042 10.1152V10.6152C11.8512 10.6152 13.3562 12.1194 13.3562 13.9662H13.8562Z",
    fill: "#6B696A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.007 26.6762C18.966 23.0382 16.757 19.9132 13.614 18.5322C13.263 18.8222 12.876 19.0702 12.462 19.2702C15.588 20.2962 17.861 23.2212 17.904 26.6762H2.105C2.149 23.2212 4.421 20.2962 7.547 19.2702C7.133 19.0702 6.746 18.8222 6.395 18.5322C3.251 19.9132 1.043 23.0382 1.002 26.6762H1V27.7762H19.009V26.6762H19.007Z",
    fill: "#6B696A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.007 26.6762C18.966 23.0382 16.757 19.9132 13.614 18.5322C13.263 18.8222 12.876 19.0702 12.462 19.2702C15.588 20.2962 17.861 23.2212 17.904 26.6762H2.105C2.149 23.2212 4.421 20.2962 7.547 19.2702C7.133 19.0702 6.746 18.8222 6.395 18.5322C3.251 19.9132 1.043 23.0382 1.002 26.6762H1V27.7762H19.009V26.6762H19.007Z",
    stroke: "#6B696A",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8166 25.6647H8.19263L9.40063 20.4297H10.6086L11.8166 25.6647Z",
    fill: "#368FEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8166 25.6647H8.19263L9.40063 20.4297H10.6086L11.8166 25.6647Z",
    stroke: "#368FEF",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47778 12.678H15.5318V7L13.6888 9.567L10.2158 7L7.40778 9.567L4.47778 7V12.678Z",
    fill: "#368FEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47778 12.678H15.5318V7L13.6888 9.567L10.2158 7L7.40778 9.567L4.47778 7V12.678Z",
    stroke: "#368FEF",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 9,
    r: 9,
    fill: "#368FEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0547 13.8125C18.2891 14.0469 18.6875 14.0469 18.9219 13.8125L25.8125 6.92188C26.0469 6.6875 26.0469 6.28906 25.8125 6.05469L24.9688 5.21094C24.7344 4.97656 24.3594 4.97656 24.125 5.21094L18.5 10.8359L15.8516 8.21094C15.6172 7.97656 15.2422 7.97656 15.0078 8.21094L14.1641 9.05469C13.9297 9.28906 13.9297 9.6875 14.1641 9.92188L18.0547 13.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltInAdmin);
export default __webpack_public_path__ + "static/media/built_in_admin.7d32af72bb3c124b094a0f523a313d5d.svg";
export { ForwardRef as ReactComponent };